import { render } from "./AppFile.vue?vue&type=template&id=33ca4cba"
import script from "./AppFile.vue?vue&type=script&lang=js"
export * from "./AppFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__